import axiosService from '@Lib/axiosService';

const url = `${process.env.URL}`;

export const getPermissions = () => {
  return axiosService.get(`${url}/permissions/byRoles`).then((res) => res.data.data);
};

export const togglePermission = ({ body }) => {
  return axiosService.put(`${url}/permissions/byRoles`, body).then((res) => res.data);
};

export const getUserRoles = ({ projectId }) => {
  return axiosService.get(`${url}/projects/${projectId}/userRoles`).then((res) => res.data);
};

export const setRole = ({ projectId, body }) => {
  return axiosService.put(`${url}/projects/${projectId}/userRoles`, body).then((res) => res.data);
};

export const getWarehouses = (params) => {
  return axiosService.get(`${url}/warehouses`, params).then((res) => res.data.data);
};

export const getWarehouseDetail = ({ warehouseId }) => {
  return axiosService.get(`${url}/warehouses/${warehouseId}`).then((res) => res.data.data);
};

export const addNewWarehouse = (body) => {
  return axiosService.post(`${url}/warehouses`, body).then((res) => res.data.data);
};

export const editWarehouse = ({ warehouseId, body }) => {
  return axiosService.put(`${url}/warehouses/${warehouseId}`, body).then((res) => res.data.data);
};

export const getWarehouseLocation = (params) => {
  return axiosService.get(`${url}/warehouseLocations`, params).then((res) => res.data.data);
};

export const getWarehouseLocationDetail = ({ warehouseId }) => {
  return axiosService.get(`${url}/warehouseLocations/${warehouseId}`).then((res) => res.data.data);
};

export const addNewWarehouseLocation = (body) => {
  return axiosService.post(`${url}/warehouseLocations`, body).then((res) => res.data.data);
};

export const editWarehouseLocation = ({ warehouseId, body }) => {
  return axiosService
    .put(`${url}/warehouseLocations/${warehouseId}`, body)
    .then((res) => res.data.data);
};

export const deleteWarehouseLocation = (warehouseId) => {
  return axiosService
    .delete(`${url}/warehouseLocations/${warehouseId}`)
    .then((res) => res.data.data);
};

export const getCompanyProfile = () => {
  return axiosService.get(`${url}/settings/company-profile`).then((res) => res.data);
};

export const updateCompanyProfile = (body) => {
  return axiosService.put(`${url}/settings/company-profile`, body).then((res) => res.data);
};

export const getSiteBranding = () => {
  return axiosService.get(`${url}/settings/site-branding`).then((res) => res.data);
};

export const updateSiteBranding = (body) => {
  return axiosService.put(`${url}/settings/site-branding`, body).then((res) => res.data);
};

export const getAppSwitcherSettings = () => {
  return axiosService.get(`${url}/settings/app-switcher`).then((res) => res.data);
};

export const updateAppSwitcherSettings = (body) => {
  return axiosService.put(`${url}/settings/app-switcher`, body).then((res) => res.data);
};


export const getDailyReportNotificationSettings = () => {
  return axiosService.get(`${url}/settings/daily-report-notification`).then((res) => res.data);
};

export const updateDailyReportNotificationSettings = (body) => {
  return axiosService.put(`${url}/settings/daily-report-notification`, body).then((res) => res.data);
};

export const testDailyReportTelegram = (body) => {
  return axiosService
    .post(`${url}/settings/daily-report-notification/test-telegram`, body)
    .then((res) => res.data);
};

export const testDailyReportZaloBot = (body) => {
  return axiosService
    .post(`${url}/settings/daily-report-notification/test-zalo-bot`, body)
    .then((res) => res.data);
};

export const fetchDailyReportZaloBotChats = (body) => {
  return axiosService
    .post(`${url}/settings/daily-report-notification/zalo-bot-chats`, body)
    .then((res) => res.data);
};

export const fetchDailyReportTelegramChats = (body) => {
  return axiosService
    .post(`${url}/settings/daily-report-notification/telegram-chats`, body)
    .then((res) => res.data);
};
